import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  NOTIFICATION_TYPES,
  useRealtimeNotificationListener,
} from '../../modules/RealtimeNotificationsProvider';
import type { ClientTasksUpdatedNotification } from '../../modules/RealtimeNotificationsProvider/types/clientTasksUpdated';
import type { NextTaskItem } from '../../pages/Dashboard/components/NextTasks/api';
import { applyClientTasksRealtimePatch } from '../../pages/Dashboard/components/NextTasks/applyClientTasksRealtimePatch';
import {
  DASHBOARD_NEXT_TASKS_QUERY_KEY,
  getDashboardNextTasksQueryKey,
} from '../../pages/Dashboard/components/NextTasks/queryKeys';

const TaskCompletionListener = () => {
  const queryClient = useQueryClient();

  useRealtimeNotificationListener((notification) => {
    if (
      notification.type !== NOTIFICATION_TYPES.TASK_COMPLETED &&
      notification.type !== NOTIFICATION_TYPES.CLIENT_TASKS_UPDATED
    ) {
      return;
    }

    if (notification.type === NOTIFICATION_TYPES.CLIENT_TASKS_UPDATED) {
      const clientTasksData = notification.data;
      const payload =
        clientTasksData && typeof clientTasksData === 'object' && 'data' in clientTasksData
          ? clientTasksData.data
          : clientTasksData;
      const clientId =
        payload && typeof payload === 'object' && 'client_id' in payload
          ? (payload as { client_id: number | string }).client_id
          : undefined;
      queryClient.setQueryData<NextTaskItem[]>(
        getDashboardNextTasksQueryKey(clientId),
        (old) =>
          applyClientTasksRealtimePatch(old, notification as ClientTasksUpdatedNotification),
      );
    }

    queryClient.invalidateQueries({
      queryKey: [DASHBOARD_NEXT_TASKS_QUERY_KEY],
      refetchType: 'active',
    });
  });

  return null;
};

export default TaskCompletionListener;